import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import moment from "moment"
import { useSnackbar } from 'notistack';

import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';

import DatepickerV2 from '../../../components/shared/DatepickerV2';
import FuelTypeAutocomplete from '../../../components/formik-form-components/FuelTypeAutocomplete';
import { getItemFormProps, getSearchFuelFromProps, getSearchFuelStationProps, getSearchFuelTypeProps } from '../../../components/generics/propsHelper';
import VehicleAutocomplete from '../../../components/formik-form-components/VehicleAutocomplete';
import FuelStationsAutocomplete from '../../../components/formik-form-components/FuelStationsAutocomplete';
import FuelFromAutoComplete from '../../../components/formik-form-components/FuelFromAutoComplete';
import InputField from '../../../components/generics/InputField';
import ReportViewAutocomplete from '../../../components/formik-form-components/ReportViewAutocomplete';
import StoreAutocomplete from '../../../components/formik-form-components/StoreAutocomplete';
import ItemAutocomplete from '../../../components/formik-form-components/ItemAutocomplete';
import FuelReportSummaryList from './FuelReportSummaryList';
import { enterFunctionV2, focusElement, handlekeyDown } from '../../../components/generics/helper';
import FuelReportList from './FuelReportList';
import { fetchApi } from '../../../services/apiService';
import { Loader } from '../../../components/generics/Loader';

const FuelReportFilter = () => {
  const userToken = useSelector((state) => state.login.userToken);
  const { enqueueSnackbar } = useSnackbar();
  const vehicleNoRef = useRef(null);
  const fuelTypeRef = useRef(null);
  const fuelStationRef = useRef(null);
  const fuelFromRef = useRef(null);
  const fuelItemRef = useRef(null);
  const fuelStoreRef = useRef(null);
  const reportTypeFilterRef = useRef(null);

  const initFilterValues = {
    fromDate: moment(new Date()).format("YYYY-MM-DD"), toDate: moment(new Date()).format("YYYY-MM-DD"), searchVehicleIds: '', searchVehicleNos: [], fuelIssuedFrom: '', searchFuelStationIds: '', searchFuelStationNames: [], searchFuelStationTypes: '', searchFuelStationTypeNames: [],
    searchStoreIds: '', searchStoreNames: [], searchItemIds: '', searchItemNames: [], searchBillNo: '', searchReportingView: "1", searchReportViewName: 'Summary View', showTable: false, dateType: 'FuelDate',
  }

  const [filters, setFilters] = useState(initFilterValues)
  const [resetDate, setResetDate] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    focusElement('fuelDate');

    if (filters.searchReportingView === '1') {
      setFilters(prev => ({ ...prev, dateType: 'FuelDate' }));
    }
  }, [filters.searchReportingView]);

  const searchFuelReportData = async () => {
    setFilters((prev) => ({ ...prev, showTable: false }))
    setIsLoading(true);
    try {
      let fuelReportParams = {}
      if (filters?.searchVehicleIds !== '') {
        fuelReportParams = { ...fuelReportParams, searchVehicleIds: filters?.searchVehicleIds };
      }
      if (filters?.fuelIssuedFrom !== '') {
        fuelReportParams = { ...fuelReportParams, fuelIssuedFrom: filters?.fuelIssuedFrom };
      }
      if (filters?.searchFuelStationIds !== '') {
        fuelReportParams = { ...fuelReportParams, searchFuelStationIds: filters?.searchFuelStationIds };
      }
      if (filters?.searchFuelStationTypes !== '') {
        fuelReportParams = { ...fuelReportParams, searchFuelTypes: filters?.searchFuelStationTypes };
      }
      if (filters?.searchStoreIds !== '') {
        fuelReportParams = { ...fuelReportParams, searchStoreIds: filters?.searchStoreIds };
      }
      if (filters?.searchItemIds !== '') {
        fuelReportParams = { ...fuelReportParams, searchItemIds: filters?.searchItemIds };
      }
      if (filters?.searchBillNo !== '') {
        fuelReportParams = { ...fuelReportParams, searchBillNo: filters?.searchBillNo };
      }
      if (filters.dateType === 'FuelDate') {
        fuelReportParams = { ...fuelReportParams, fuelFromDate: moment(filters?.fromDate).format('YYYY-MM-DD'), fuelToDate: moment(filters?.toDate).format('YYYY-MM-DD') }
      } else {
        fuelReportParams = { ...fuelReportParams, transactionFromDate: moment(filters?.fromDate).format('YYYY-MM-DD'), transactionToDate: moment(filters?.toDate).format('YYYY-MM-DD') }
      }
      fuelReportParams.searchReportingView = filters.searchReportingView === '2' ? 'D' : 'S';

      const response = await fetchApi('transactions/getFuelVouchersForReport', fuelReportParams, userToken);
      setIsLoading(false);
      if (response.status === 'Ok' && response.data.responseStatus === 'Ok') {
        const isDetailView = filters.searchReportingView === '2';
        const reportData = isDetailView ? response.data.fuelVouchers : response.data.fuelSummaryData;
        if (reportData && reportData.length > 0) {
          enqueueSnackbar('Fuel Report Data Loaded Successfully', { variant: 'success', key: Date.now() });
          setTableData(reportData);
          setFilters((prev) => ({ ...prev, showTable: true }))
        } else {
          enqueueSnackbar('Ooops! No Record Found', { variant: 'error' });
          setTableData([]);
          setFilters((prev) => ({ ...prev, showTable: true }))
        }
      }
    } catch (err) {
      enqueueSnackbar('Fuel Report List Loading Failed', { variant: 'error' });
      setTableData([])
    }
  }
  const fuelReportFilterReset = () => {
    setFilters({ ...initFilterValues });
    vehicleNoRef.current.resetAutocomplete();
    reportTypeFilterRef.current.resetAutocomplete();
    if (fuelStationRef.current) {
      fuelStationRef.current.resetAutocomplete();
    }
    if (fuelTypeRef.current) {
      fuelTypeRef.current.resetAutocomplete();
    }
    if (fuelStoreRef.current) {
      fuelStoreRef.current.resetAutocomplete();
    }
    if (fuelItemRef.current) {
      fuelItemRef.current.resetAutocomplete();
    }
    fuelFromRef.current.resetAutocomplete();
    setResetDate(true)

  }

  return (
    <>
      <div className="report--filter--wrapper fuel--report--filter" style={{ borderBottom: '0px', paddingBottom: '0px' }}>
        <div className="fuel--voucher--radio--wrap">
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              value={filters.dateType}
              onChange={(e) => setFilters(prev => ({ ...prev, dateType: e.target.value, showTable: false }))}
              className="retrieve--by--filter--options--container"
            >
              <FormControlLabel
                value="FuelDate"
                id="fuelDate"
                style={{ fontWeight: '600 !important' }}
                control={<Radio />}
                label="Fuel Date"
                onKeyDown={(e) => enterFunctionV2(e, 'transactionEntryDate', '')}
              />
              <FormControlLabel
                value="TransactionEntryDate"
                id="transactionEntryDate"
                control={<Radio />}
                label="Transaction Entry Date"
                disabled={filters.searchReportingView === '1'}
                onKeyDown={(e) => enterFunctionV2(e, 'fromDate', 'fuelDate')}
              />
            </RadioGroup>
          </FormControl>
        </div>
        <div className="input--container">
          <ReportViewAutocomplete
            id="frReportTypeIds" nextId="fromDate" prevId="transactionEntryDate"
            name="frReportTypeIds"
            label={"Report Type"}
            searchPlaceholder={"Search By Report Type"}
            noDataLabel={"No Report Type Found"}
            width='100%'
            selectedValues={[filters.searchReportingView || '1']}
            onSelect={(selectedReportingView, currentSelection) => {
              setFilters(prev => ({ ...prev, searchReportingView: currentSelection?.id, searchReportViewName: currentSelection?.label, showTable: false }));
            }}
            onRemove={() => {
              setFilters(prev => ({ ...prev, searchReportingView: '1', searchReportViewName: 'Summary View', showTable: false }));
            }}
            ref={reportTypeFilterRef}
          />
        </div>
        <div className="input--container" >
          <DatepickerV2
            name={'filter_from_dt'}
            type="filter_from_dt"
            className=""
            Reset={resetDate}
            star={true}
            label={filters.dateType === 'FuelDate' ? "Fuel From Date" : "Txn. Entry From Date"}
            id="fromDate"
            emptyField={''}
            dateChange={(newValue) => {
              setResetDate(false);
              setFilters(previousFilters => ({ ...previousFilters, fromDate: moment(newValue).format('YYYY-MM-DD'), showTable: false }));
              focusElement('toDate');
            }}
          />
        </div>
        <div className="input--container"  >
          <DatepickerV2
            name={'filter_to_dt'}
            type="filter_to_dt"
            className=""
            Reset={resetDate}
            label={filters.dateType === 'FuelDate' ? "Fuel To Date" : "Txn. Entry To Date"}
            id="toDate"
            fromDate={filters?.fromDate}
            star={true}
            enableFuture={true}
            emptyField={''}
            dateChange={(newValue) => {
              setResetDate(false);
              setFilters(previousFilters => ({ ...previousFilters, toDate: moment(newValue).format('YYYY-MM-DD'), showTable: false }));
              focusElement('frVehicleNo');
            }}
          />
        </div>
        <div className="input--container" >
          <VehicleAutocomplete
            id="frVehicleNo"
            nextId="frFuelFrom"
            prevId="toDate"
            ref={vehicleNoRef}
            width="100%"
            listWidth={300}
            allOption={true}
            selectedValues={filters?.searchVehicleIds !== '' ? [filters?.searchVehicleIds] : []}
            label='Vehicle Number'
            searchPlaceholder="Search By Vehicle No."
            noDataLabel="No Vehicle Found"
            onlyLoginBranchAppVehicles='Y'
            isCompulsory={false}
            singleSelect={false}
            onSelect={(selectedVehicleNos, currentSelection) => {
              let searchVehicleIds = '';
              let searchVehicleNos = '';
              if (selectedVehicleNos.length > 0) {
                searchVehicleIds = selectedVehicleNos.map((vm) => vm.vehicleId).sort().join(',');
                searchVehicleNos = selectedVehicleNos.map((vm) => vm.vehicleNo).sort();
              }
              setFilters(previousFilters => ({ ...previousFilters, searchVehicleIds: searchVehicleIds, searchVehicleNos: searchVehicleNos, showTable: false }));
            }}
            onRemove={(selectedVehicleNos, currentSelection) => {
              let searchVehicleIds = '';
              let searchVehicleNos = '';
              if (selectedVehicleNos.length > 0) {
                searchVehicleIds = selectedVehicleNos.map((vm) => vm.vehicleId).sort().join(',');
                searchVehicleNos = selectedVehicleNos.map((vm) => vm.vehicleNo).sort();
              }
              setFilters(previousFilters => ({ ...previousFilters, searchVehicleIds: searchVehicleIds, searchVehicleNos: searchVehicleNos, showTable: false }));
            }}
          />
        </div>
        <div className="input--container" >
          <FuelFromAutoComplete
            {...getSearchFuelFromProps()}
            id="frFuelFrom"
            label="Fuel From"
            name="frFuelFrom"
            prevId='frVehicleNo'
            nextId={filters?.fuelIssuedFrom === 2 ? "frFuelStation" : filters?.fuelIssuedFrom === 1 ? "frFuelStore" : filters?.fuelIssuedFrom === "" ? "frBillNo" : ''}
            ref={fuelFromRef}
            selectedValues={filters?.fuelIssuedFrom !== '' ? [filters?.fuelIssuedFrom] : []}
            onSelect={(selectedCategory, currentSelection) => {
              setFilters(prevFilters => {
                let updatedFilters = { ...prevFilters, fuelIssuedFrom: currentSelection.id, showTable: false };
                if (currentSelection.id === 1) {
                  updatedFilters.searchFuelStationIds = '';
                  updatedFilters.searchFuelStationTypes = '';
                } else if (currentSelection.id === 2) {
                  updatedFilters.searchStoreIds = '';
                  updatedFilters.searchItemIds = '';
                }
                return updatedFilters;
              });

            }}
            onRemove={(selectedCategory, currentSelection) => {
              setFilters(previousFilters => ({ ...previousFilters, fuelIssuedFrom: '', showTable: false }));
            }}
          />
        </div>
      </div>
      <div className="report--filter--wrapper fuel--report--filter" style={{ margin: '0px', zIndex: 3, borderTop: '0px', paddingTop: '0px' }}>
        {filters?.fuelIssuedFrom === 2 && <>
          <div className="input--container"  >
            <FuelStationsAutocomplete
              {...getSearchFuelStationProps()}
              id="frFuelStation"
              label="Fuel Station Name"
              name="frFuelStation"
              prevId='fuelFrom'
              nextId='fuelType'
              ref={fuelStationRef}
              selectedValues={filters?.searchFuelStationIds !== '' ? [filters?.searchFuelStationIds] : []}
              listWidth={390}
              onSelect={(selectedFuelStation, currentSelection) => {
                let searchFuelStationIds = '';
                let searchFuelStationNames = [];
                if (selectedFuelStation.length > 0) {
                  searchFuelStationIds = selectedFuelStation.map(st => st.fuelStationId).sort().join(',');
                  searchFuelStationNames = selectedFuelStation.map(st => st.fuelStationName).sort();
                }
                setFilters(previousFilters => ({ ...previousFilters, searchFuelStationIds, searchFuelStationNames, showTable: false }))
              }}
              onRemove={(selectedFuelStation, currentSelection) => {
                let searchFuelStationIds = '';
                let searchFuelStationNames = [];
                if (selectedFuelStation.length > 0) {
                  searchFuelStationIds = selectedFuelStation.map(st => st.fuelStationId).sort().join(',');
                  searchFuelStationNames = selectedFuelStation.map(st => st.fuelStationName).sort();
                }
                setFilters(previousFilters => ({ ...previousFilters, searchFuelStationIds, searchFuelStationNames, showTable: false }))
              }}
            />
          </div>
          <div className="input--container"  >
            <FuelTypeAutocomplete
              {...getSearchFuelTypeProps()}
              id="frFuelType"
              label="Fuel Type"
              name="frFuelType"
              prevId="frFuelStation"
              nextId='billNo'
              ref={fuelTypeRef}
              selectedValues={filters?.searchFuelStationTypes !== '' ? [filters?.searchFuelStationTypes] : []}
              onSelect={(selectedFuelType, currentSelection) => {
                let searchFuelStationTypes = '';
                let searchFuelStationTypeNames = [];
                if (selectedFuelType.length > 0) {
                  searchFuelStationTypes = selectedFuelType.map((st) => st.stationId).sort().join(',');
                  searchFuelStationTypeNames = selectedFuelType.map(st => st.label).sort();
                }
                setFilters(previousFilters => ({ ...previousFilters, searchFuelStationTypes, searchFuelStationTypeNames, showTable: false }));
              }}
              onRemove={(selectedFuelType, currentSelection) => {
                let searchFuelStationTypes = '';
                let searchFuelStationTypeNames = [];
                if (selectedFuelType.length > 0) {
                  searchFuelStationTypes = selectedFuelType.map((st) => st.stationId).sort().join(',');
                  searchFuelStationTypeNames = selectedFuelType.map(st => st.label).sort();
                }
                setFilters(previousFilters => ({ ...previousFilters, searchFuelStationTypes, searchFuelStationTypeNames, showTable: false }));
              }}
            />
          </div>
        </>}
        {filters?.fuelIssuedFrom === 1 && <>
          <div className="input--container" >
            <StoreAutocomplete
              name="frFuelStore"
              id="frFuelStore"
              listWidth='350'
              prevId='frFuelFrom'
              nextId='frItemId'
              label="Fuel Store Name"
              singleSelect={false}
              isCompulsory={false}
              ref={fuelStoreRef}
              allOption={false}
              selectedValues={filters?.searchStoreIds !== '' ? [filters?.searchStoreIds] : []}
              onSelect={(selectedFuelStore, currentSelection) => {
                let searchStoreIds = '';
                let searchStoreNames = [];
                if (selectedFuelStore.length > 0) {
                  searchStoreIds = selectedFuelStore.map(st => st.storeId).sort().join(',');
                  searchStoreNames = selectedFuelStore.map(st => st.storeDisplayName).sort();
                }
                setFilters(previousFilters => ({ ...previousFilters, searchStoreIds, searchStoreNames, showTable: false }))
              }}
              onRemove={(selectedFuelStore, currentSelection) => {
                let searchStoreIds = '';
                let searchStoreNames = [];
                if (selectedFuelStore.length > 0) {
                  searchStoreIds = selectedFuelStore.map(st => st.storeId).sort().join(',');
                  searchStoreNames = selectedFuelStore.map(st => st.storeDisplayName).sort();
                }
                setFilters(previousFilters => ({ ...previousFilters, searchStoreIds, searchStoreNames, showTable: false }))
              }
              }
            />
          </div>
          <div className="input--container" >
            <ItemAutocomplete
              {...getItemFormProps()}
              name="frItemId"
              id="frItemId"
              nextId="frBillNo"
              prevId="frFuelStore"
              ref={fuelItemRef}
              label="Fuel Item"
              singleSelect={false}
              isCompulsory={false}
              isFormikFormField={false}
              onlyFuels='Y'
              listWidth={500}
              forAllItems={'Y'}
              onlyLoginBranchMappedModelsItems={true}
              selectedValues={filters?.searchItemIds !== '' ? [filters?.searchItemIds] : []}
              onSelect={(selectedItem, currentSelection) => {
                let searchItemIds = '';
                let searchItemNames = [];
                if (selectedItem.length > 0) {
                  searchItemIds = selectedItem.map(it => it.itemId).sort().join(',');
                  searchItemNames = selectedItem.map(it => it.itemName).sort();
                }
                setFilters(previousFilters => ({ ...previousFilters, searchItemIds, searchItemNames, showTable: false }))
              }}
              onRemove={(selectedItem, currentSelection) => {
                let searchItemIds = '';
                let searchItemNames = [];
                if (selectedItem.length > 0) {
                  searchItemIds = selectedItem.map(it => it.itemId).sort().join(',');
                  searchItemNames = selectedItem.map(it => it.itemName).sort();
                }
                setFilters(previousFilters => ({ ...previousFilters, searchItemIds, searchItemNames, showTable: false }))
              }}
            />
          </div>
        </>
        }

        <div className="input--container">
          <InputField name='frBillNo' id='frBillNo' label='Bill No.' isCompulsory={false} handleOnChange={(e) => { setFilters((prev) => ({ ...prev, searchBillNo: e.target.value, showTable: false })) }}
            onKeyDown={(e) => { handlekeyDown(e, filters?.fuelIssuedFrom === 1 ? 'itemId' : 'fuelType', 'searchBtn', 'billNo') }} value={filters?.searchBillNo} />
        </div>
        <div className='btn--container'>
          <div className="search--btn" id="searchBtn" tabIndex={0} style={{ marginLeft: "0" }} onClick={() => { searchFuelReportData() }}
            onKeyDown={(e) => { handlekeyDown(e, 'billNo', 'resetBtn', 'searchBtn') }
            }>
            Search
          </div>
          <div className="dashed--btn" tabIndex={0} id='resetBtn' style={{ justifyContent: "start", marginLeft: "10px" }}
            onKeyDown={(e) => { handlekeyDown(e, 'searchBtn', 'fuelDate', 'resetBtn') }
            }
          >
            <div onClick={() => fuelReportFilterReset()} >Reset</div>
          </div>
        </div>
      </div>
      <div className="report--container">
        {isLoading && <div style={{ width: "100%", textAlign: 'center', marginTop: '10px' }}><Loader /></div>}
        {filters?.showTable && (
          filters.searchReportingView === '2' ? (
            <FuelReportList filters={filters} tableData={tableData} />)
            : (<FuelReportSummaryList filters={filters} tableData={tableData} />)
        )}
      </div>
    </>
  )
}

export default FuelReportFilter
